"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const L = __importStar(require("leaflet"));
const map = L.map("map_ads", { zoomControl: false }).setView([46.2276, 2.2137], 6);
// Add credits to map
L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    referrerPolicy: "strict-origin-when-cross-origin",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
}).addTo(map);
/* Info box on the top right */
class InfoBox extends L.Control {
    constructor() {
        super({ position: "topright" });
        this.onAdd = () => {
            this.update(null);
            return this._div;
        };
        this.update = (props) => {
            const title = props ? `${props.nom} (${props.code_insee})` : `Nombre d'ADS`;
            const content = props
                ? this.getInfoboxContent(props.ads_count, props.expected_ads_count, props.ads_completee_pourcentage)
                : `Survolez un département pour <br/>afficher le nombre d'ADS enregistrées`;
            this._div.innerHTML = `
          <div class="fr-tile fr-enlarge-link fr-tile--horizontal" style="opacity: 0.8">
            <div class="fr-tile__body">
                <h4 class="fr-tile__title">${title}</h4>
                <p class="fr-tile__desc">${content}</p>
            </div>
        </div>
        `;
        };
        this.getInfoboxContent = (ads_count, expected_ads_count, ads_completee_pourcentage) => {
            const infos = [
                `&rarr; ${ads_count} ADS ${ads_count > 1 ? "enregistrées" : "enregistrée"}`,
            ];
            if (expected_ads_count !== null) {
                infos.push(`&rarr; ${expected_ads_count} ADS au total <br />dans la préfecture (estimation)`);
                infos.push(`<div class="fr-mt-1w"><strong>Taux de remplissage: ${Math.round((ads_count / expected_ads_count) * 100)}%</strong></div>`);
            }
            else {
                infos.push("Nombre d'ADS total inconnu pour cette préfecture");
            }
            infos.push(`<div><strong>Taux de vérification des ADS remplies: ${ads_completee_pourcentage}%</strong></div>`);
            return infos.join("<br />");
        };
        this._div = L.DomUtil.create("div", "leaflet-info");
    }
}
function displayStatsMap(data) {
    const unknown_color = "#0000FF";
    const colors = new Map([
        [0, "#A0A0A0"],
        [1, "#FF0000"],
        [30, "#FFA500"],
        [70, "#00FF00"],
    ]);
    const getFillColor = (ads_count, expected_ads_count) => {
        if (expected_ads_count === null) {
            if (ads_count) {
                return unknown_color;
            }
            else {
                return colors.get(0);
            }
        }
        const pct_filled = (ads_count / (expected_ads_count || 0)) * 100;
        const rsorted = Array.from(colors.keys())
            .sort((a, b) => a - b)
            .reverse();
        const key = rsorted.find((e) => pct_filled - e >= 0);
        return colors.get(key || 0);
    };
    const info = new InfoBox().addTo(map);
    const geojson = L.geoJSON(data, {
        style: (feature) => {
            return {
                fillColor: getFillColor(feature === null || feature === void 0 ? void 0 : feature.properties.ads_count, feature === null || feature === void 0 ? void 0 : feature.properties.expected_ads_count),
                fillOpacity: 0.5,
                color: "#777",
                weight: 1,
            };
        },
        onEachFeature: (feature, layer) => {
            layer.on({
                mouseover: () => {
                    layer.setStyle({
                        fillOpacity: 1,
                    });
                    info.update(feature.properties);
                },
                mouseout: (e) => {
                    geojson.resetStyle(e.target);
                    info.update(null);
                },
                click: () => {
                    map.fitBounds(layer.getBounds());
                    info.update(feature.properties);
                    window.location.href = `#prefecture_${feature.properties.code_insee}`;
                },
            });
        },
    }).addTo(map);
    const legend = new L.Control({ position: "bottomright" });
    legend.onAdd = () => {
        const div = L.DomUtil.create("div");
        const grades = Array.from(colors.keys()).sort((a, b) => a - b);
        let description = `
        <ul class="fr-tile__desc fr-p-0" style="display: flex; flex-direction: column; gap: 5px;">`;
        description += `
          <li class="fr-grid-row fr-grid-row--bottom">
            <i class="fr-mr-3v" style="background:${unknown_color}; width: 24px; height: 24px;"></i>
            Taux de remplissage inconnu
          </li>
        `;
        for (let i = 0; i < grades.length; i++) {
            const label = i === 0 ? "Aucune ADS enregistrée" : `≥ ${grades[i]}%`;
            description += `
            <li class="fr-grid-row fr-grid-row--bottom">
              <i class="fr-mr-3v" style="background:${colors.get(grades[i])}; width: 24px; height: 24px;"></i>
              ${label}
            </li>
          `;
        }
        description += "</ul>";
        div.innerHTML = `
      <div class="fr-tile fr-enlarge-link fr-tile--horizontal" style="opacity: 0.8">
        <div class="fr-tile__body">
          ${description}
        </div>
      </div>
      `;
        return div;
    };
    legend.addTo(map);
}
// Call API to display stats
fetch("/api/stats/geojson/per-prefecture/")
    .then((response) => response.json())
    .then(displayStatsMap);
